import React from "react";
import { StoreInterface } from "../../assets/interfaces";
import { getWhatsappLink } from "../../assets/js/utils/utils";
import CartContext from "../../contexts/cart-context";
import CurrencySwitcher from "../ui/currency-switcher";
import ImageWithPlaceholder from "../ui/image-with-placeholder";
import CartContextV2 from "@/contexts/cart-context-v2";

interface Props {
  store: StoreInterface;
}

const ProductPageHeader: React.FC<Props> = ({ store }) => {
  const { currencies, changeCurrency } = CartContextV2.useContainer();

  return (
    <header className="text-primary-500 h-16 sm:h-17.5 md:h-[75px] px-5 sm:px-7.5 border-b border-grey-border border-opacity-50 flex flex-col items-center justify-center fixed w-full bg-white top-0 z-[998]">
      <div className="store-container justify-between flex items-center w-full">
        <figure className="">
          {store?.has_paid_subscription ? (
            // <img src={logo} alt="" className="h-full w-full object-cover" />
            <ImageWithPlaceholder
              image={store?.logo}
              text={store?.name}
              className="h-10 w-10 text-xl sm:text-2lg font-bold"
            />
          ) : (
            <img src="/images/logos/primary.svg" alt="" className="h-5 sm:h-5.5 md:h-6" />
          )}
        </figure>
        <div className="flex items-center space-x-2.5">
          {currencies.options.length > 1 && (
            <div className="flex items-center space-x-1 text-black-secondary hover:text-black-muted transition-all ease-out px-3.75 py-0.5 rounded-full bg-grey-fields-100">
              <CurrencySwitcher
                noBg
                selected={currencies.active}
                currencies={currencies.options}
                setCurrency={changeCurrency}
              />
            </div>
          )}
          <a
            href={getWhatsappLink(store?.phone, "")}
            target="_blank"
            rel="noreferrer"
            className="flex items-center space-x-1 text-black-secondary hover:text-black-muted transition-all ease-out px-2 py-1.5 rounded-[30px] bg-grey-fields-100 py-2 px-3 sm:px-3.75 sm:py-2.5"
          >
            {/* prettier-ignore */}
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2672_10539)">
            <path d="M0 22L1.55492 16.3536C0.5936 14.6963 0.0893027 12.8194 0.0945558 10.9007C0.0945558 4.88831 5.01146 0 11.0473 0C13.9785 0 16.7311 1.13451 18.7956 3.19439C20.8653 5.25428 22.0052 7.99382 22 10.9059C22 16.9183 17.0831 21.8066 11.042 21.8066H11.0368C9.20343 21.8066 7.40162 21.3465 5.79942 20.4786L0 22ZM6.07784 18.5076L6.40878 18.7063C7.80611 19.5323 9.4083 19.9663 11.042 19.9715H11.0473C16.064 19.9715 20.1509 15.9092 20.1509 10.9111C20.1509 8.4905 19.2053 6.21626 17.4876 4.50143C15.7698 2.7866 13.4795 1.84553 11.0473 1.84553C6.03056 1.8403 1.94365 5.90257 1.94365 10.9007C1.94365 12.6103 2.42168 14.278 3.33572 15.721L3.5511 16.0661L2.6318 19.4068L6.07784 18.5076Z" fill="white"/>
            <path d="M0.383789 21.6185L1.88618 16.1656C0.956377 14.571 0.467839 12.7568 0.467839 10.9061C0.473092 5.10285 5.21664 0.381836 11.0476 0.381836C13.879 0.381836 16.5318 1.47975 18.528 3.46644C20.5242 5.45313 21.6221 8.09857 21.6221 10.9113C21.6221 16.7145 16.8733 21.4355 11.0476 21.4355H11.0423C9.27203 21.4355 7.53326 20.9912 5.98885 20.1547L0.383789 21.6185Z" fill="url(#paint0_linear_2672_10539)"/>
            <path d="M0 22L1.55492 16.3536C0.5936 14.6963 0.0893027 12.8194 0.0945558 10.9007C0.0945558 4.88831 5.01146 0 11.0473 0C13.9785 0 16.7311 1.13451 18.7956 3.19439C20.8653 5.25428 22.0052 7.99382 22 10.9059C22 16.9183 17.0831 21.8066 11.042 21.8066H11.0368C9.20343 21.8066 7.40162 21.3465 5.79942 20.4786L0 22ZM6.07784 18.5076L6.40878 18.7063C7.80611 19.5323 9.4083 19.9663 11.042 19.9715H11.0473C16.064 19.9715 20.1509 15.9092 20.1509 10.9111C20.1509 8.4905 19.2053 6.21626 17.4876 4.50143C15.7698 2.7866 13.4795 1.84553 11.0473 1.84553C6.03056 1.8403 1.94365 5.90257 1.94365 10.9007C1.94365 12.6103 2.42168 14.278 3.33572 15.721L3.5511 16.0661L2.6318 19.4068L6.07784 18.5076Z" fill="url(#paint1_linear_2672_10539)"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.31054 6.34197C8.10567 5.88712 7.89029 5.87667 7.69593 5.87144C7.53834 5.86621 7.35448 5.86621 7.17062 5.86621C6.98676 5.86621 6.69259 5.93418 6.44044 6.20604C6.18829 6.4779 5.48438 7.13665 5.48438 8.48028C5.48438 9.81868 6.4667 11.1153 6.60329 11.2982C6.73987 11.4812 8.49965 14.3201 11.2785 15.4128C13.5899 16.3225 14.0627 16.1395 14.5617 16.0924C15.0608 16.0454 16.1797 15.4337 16.4108 14.7959C16.6367 14.158 16.6367 13.6143 16.5684 13.4993C16.5001 13.3843 16.3163 13.3163 16.0431 13.1804C15.7699 13.0444 14.4252 12.3857 14.173 12.2916C13.9209 12.2027 13.737 12.1557 13.5584 12.4275C13.3745 12.6994 12.8492 13.3111 12.6916 13.4941C12.534 13.677 12.3712 13.698 12.098 13.562C11.8249 13.4261 10.9423 13.1386 9.89698 12.2079C9.08275 11.4865 8.53117 10.5924 8.37358 10.3206C8.21599 10.0487 8.35782 9.90233 8.4944 9.7664C8.61522 9.64615 8.76756 9.44749 8.90414 9.29064C9.04072 9.1338 9.088 9.01878 9.1773 8.83579C9.26661 8.65281 9.22458 8.49596 9.15629 8.36003C9.088 8.22933 8.55219 6.88047 8.31054 6.34197Z" fill="white"/>
            </g>
            <defs>
            <linearGradient id="paint0_linear_2672_10539" x1="11.0024" y1="21.6175" x2="11.0024" y2="0.381093" gradientUnits="userSpaceOnUse">
            <stop stop-color="#20B038"/>
            <stop offset="1" stop-color="#60D66A"/>
            </linearGradient>
            <linearGradient id="paint1_linear_2672_10539" x1="11.0021" y1="21.9979" x2="11.0021" y2="0" gradientUnits="userSpaceOnUse">
            <stop stop-color="#F9F9F9"/>
            <stop offset="1" stop-color="white"/>
            </linearGradient>
            <clipPath id="clip0_2672_10539">
            <rect width="22" height="22" fill="white"/>
            </clipPath>
            </defs>
            </svg>
            <span className="text-xs sm:text-sm font-medium">Contact Seller</span>
          </a>
        </div>
      </div>
    </header>
  );
};

export default ProductPageHeader;
